const es = {
    application_title: 'Login',
    japanese: 'Japonés',
    english: 'Inglés',
    french: 'Francés',
    german: 'Alemán',
    italian: 'Italiano',
    spanish: 'Español',
    language: 'Idioma',
    login_selectscreen: 'Seleccione la pantalla',
    login_all: 'Todo',
    login_executive: 'Ejecutivo',
    login_manager: 'Manager',
    login_operator: 'Operador',
    login_forgot_password: '¿Ha olvidado su contraseña',
    user_id: 'Nombre de usuario',
    user_password: 'Contraseña',
    authorizer: 'Autorizador',
    authorizer_text: 'Nota: Introduzca la dirección de correo electrónico del autorizador. El autorizador debe ser un empleado de Konica Minolta (un usuario con un dominio konica minolta).',
    sign_in: 'Acceso',
    sign_in_error: 'Nombre de usuario o contraseña incorrectos',
    create_account: 'Crear una nueva cuenta',
    forget_password_title: 'Por favor, envíe una solicitud de restablecimiento de contraseña a la dirección de correo electrónico que aparece a continuación.',
    forget_password_email: 'dashboard-u_support2@gcp.konicaminolta.com',
    forget_password_text: 'Por favor, copie el texto de abajo, péguelo en el asunto y envíelo por correo electrónico.\n\
    >[Request] Puede dejar el mensaje principal del correo electrónico en blanco.\n\
Por favor, envíe el correo electrónico desde la dirección de correo electrónico registrada en este software.\n\
Es posible que no podamos responder a las solicitudes de direcciones de correo electrónico no registradas.\n\
Si no recibe una respuesta en un plazo de 24 horas, vuelva a enviarlo.\n\
・Por favor, tenga en cuenta que su cuenta será eliminada si no puede confirmar su ingreso en el plazo de un mes desde la recepción de este correo electrónico.\n\
・Por favor, confirme la notificación de la nueva contraseña desde la siguiente dirección de correo electrónico.\n\
"no-reply@verificationemail.com"',
    forget_password_team: 'AccurioPro Dashboard Op-Analysis Operation Team',
    privacy_statement: 'Declaración de privacidad',
    privacy_statement_contents: 'En Konica Minolta Business Solutions Europe GmbH y sus filiales, empresas asociadas y empresas matrices que se enumeran en el anexo 1. ("Konica Minolta"), nos tomamos muy en serio el tema de la privacidad. Esta política de privacidad proporciona información sobre la forma en que recopilamos, utilizamos, revelamos y gestionamos los datos personales. \ón de datos\n\
¿Quién es el controlador de datos? \n\
Konica Minolta utilizará sus datos personales mencionados a continuación. \n\
Datos personales\n\
¿Qué información recogemos sobre usted? \n\
Konica Minolta recoge su dirección de correo electrónico. \n\
Información de contacto \n\
¿Cómo se utilizará su información? \n\
Konica Minolta utiliza su información anterior sólo para los fines indicados a continuación: \n\
Identificación y; \n\n\
contacto para proporcionar la información necesaria en AccurioPro Dashboard. \n\
Información de contacto\n\
¿Cuál es nuestra base legal para procesar sus datos personales? \n\
El interés legítimo es la base legal para el tratamiento. \n\
Los intereses legítimos son a) la identificación, y b) el contacto para proporcionar la información necesaria en AccurioPro Dashboard. \n\
El interés legítimo es la base legal del tratamiento.\n\
¿Quién recibe su información? \n\
Sus datos personales anteriores serán tratados de forma estrictamente confidencial, y no serán compartidos con ningún tercero sin su previo consentimiento. \n\
Periodo de almacenamiento\n\
Período de almacenamiento\n\
Konica Minolta procesará los datos personales durante la duración de su necesidad de utilizar AccurioPro Dashboard para su asignación y continuará almacenando sólo los datos personales necesarios durante tres meses después de que se cambie su asignación o usted deje la empresa ("Cambio"). Durante el período de eliminación desde el Cambio hasta los tres meses posteriores al mismo, se eliminarán todos los datos personales que no se necesiten, ya que Konica Minolta elimina los datos personales que no se necesitan por trimestre. \n\
Almacenamiento y transferencia de datos\n\
Almacenamiento y transferencia de datos\n\
Los datos se almacenan en Alemania. Para la identificación y el contacto, Konica Minolta, Inc.  Japón es un país que garantiza un nivel adecuado de protección de datos personales decidido por la Comisión Europea. \n\
Datos personales \n\
¿Cuáles son sus derechos bajo el GDPR? \n\
Mientras Konica Minolta esté en posesión o procesando sus datos personales, usted tiene los siguientes derechos: \n\
Derecho de acceso: tiene derecho a solicitar una copia de la información que tenemos sobre usted. \n\
Derecho de rectificación: tiene derecho a corregir los datos que tenemos sobre usted que sean inexactos o incompletos. \n\
Derecho al olvido: en determinadas circunstancias, puede solicitar que los datos que tenemos sobre usted se borren de nuestros registros. \n\
Derecho a la restricción del tratamiento: cuando se den determinadas condiciones, tendrá derecho a restringir el tratamiento. \n\
Derecho a la portabilidad: tiene derecho a que los datos que tenemos sobre usted se transfieran a otra organización. \n\
Derecho de oposición: tiene derecho a oponerse a determinados tipos de tratamiento, como el marketing directo. \n\
Derecho a oponerse al tratamiento automatizado, incluida la elaboración de perfiles: también tiene derecho a que no se le apliquen los efectos jurídicos del tratamiento automatizado o la elaboración de perfiles. \n\
En caso de que Konica Minolta rechace su solicitud en virtud del derecho de acceso, le daremos una explicación razonable. \n\
Si ejerce alguno de sus derechos, envíe un correo electrónico a dashboard-u_support1@gcp.konicaminolta.com. \n\
Datos de contacto del responsable del tratamiento\n\
Datos de contacto del responsable del tratamiento \n\n\
Puede ponerse en contacto con nuestra empresa en cualquier momento si tiene alguna pregunta relacionada con el tema de la privacidad de los datos. Los datos de contacto de otras empresas se mencionan en el anexo 2.\n\
Konica Minolta Business Solutions Europe GmbH \n\
Europaallee 17\n\
30855 Langenhagen\n\
Alemania\n\
dashboard-u_support1@gcp.konicaminolta.com\n\
Datos de contacto del responsable de la protección de datos\n\
Puede ponerse en contacto con el responsable de la protección de datos de nuestra empresa en cualquier momento si tiene alguna pregunta relacionada con el tema de la protección de datos. \n\
Esta persona es \n\
Dr. Frederike Rehker \n\
Konica Minolta Business Solutions Europe GmbH \n\
Europaallee 17 \n\
30855 Langenhagen \n\
Alemania Teléfono: +49 (0)511 7404-0 \n\
Correo electrónico: dataprotection(at)konicaminolta.eu \n\
Adjunto.1 \n\
No se puede hacer nada. \n\
Konica Minolta Business Solutions Deutschland GmbH, \n\
Konica Minolta Business Solutions France S.A.S., \n\
Konica Minolta Business Solutions (UK) Limited, \n\
Konica Minolta Business Solutions Romania s.r.l., \n\
Konica Minolta Business Solutions Italia S.p.A., \n\
Konica Minolta Business Solutions Nederland B.V., \n\
Konica Minolta Business Solutions Greece S.A., \n\
Konica Minolta Business Solutions Czech spol. s r.o., \n\
Konica Minolta Hungary Business Solutions Ltd., \n\
Konica Minolta Business Solutions Polska Sp.z.o.o., \n\
Konica Minolta Business Solutions Bulgaria EOOD, \n\
Konica Minolta Business Solutions Slovenia d.o.o., \n\
Konica Minolta Croatia-Business Solutions d.o.o., \n\
Konica Minolta Slovakia spol. s.r.o., \n\
Konica Minolta Baltia UAB, \n\
Konica Minolta Business Solutions Denmark A/S, \n\
Konica Minolta Business Solutions Spain S.A., \n\
Konica Minolta Business Solutions Suecia AB, \n\
Konica Minolta Business Solutions Noruega \n\
Konica Minolta Business Solutions (Belgium) N.V., \n\
Konica Minolta Business Solutions Austria GmbH, \n\
Konica Minolta Business Solutions Portugal, Unipessoal Lda., \n\
Konica Minolta Business Solutions Finland Oy, y \n\
Konica Minolta Business Solutions Portugal, Unipessoal Lda.\n\
Konica Minolta, Inc. con sede en 2-7-2, Marunouchi, Chiyoda-ku, Tokio, Japón.\n\
Adjunto.2 \n\
Konica Minolta Business Solutions Deutschland GmbH \n\
Europaallee 17, 30855 Langenhagen, Alemania \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions France S.A.S. \n\
365-367 Route de Saint-Germain, F-78424 Carrieres-sur-Seine, Francia \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions (UK) Limited \n\
Miles Gray Road, Basildon, Essex, SS14 3AR, Reino Unido. \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Romania s.r.l.\n\
Str. Copilului nr. 18, parter, sector 1, 012178 Bucarest, Rumanía \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Italia S.p.A. \n\
Viale Certosa, 144, 20156 Milano, Italia \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Nederland B.V. \n\
Hoogoorddreef 9, Postbus 22110, 1100 CC Amsterdam, Países Bajos \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Grecia S.A. \n\
3, Messologiou Str., GR-14451 Metamorfosis, Atenas, Grecia \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Czech spol. s r.o. \n\
Brno - Židenice, Žarošická 4395/13, PSČ 628 00, República Checa \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Hungary Business Solutions Ltd. \n\
Galvani u. 4., 1117 Budapest, Hungría \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Polska Sp.z.o.o. \n\
Muszkieterów 15, 02-273 Warszawa, Polonia \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Bulgaria EOOD \n\
Biznes park Sofia 7, 1715 Sofia, Bulgaria \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Eslovenia d.o.o. \n\
Vodovodna cesta 101, 1000 Ljubljana, Eslovenia \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions d.o.o. \n\
Konica Minolta Croatia-Business Solutions d.o.o. \n\
Radnicka cesta 1a, HR-10000 Zagreb, Croacia \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Slovakia spol. s.r.o. \n\
Cernysevskeho 10, 85101 Bratislava, República Eslovaca \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Baltia UAB \n\
J. Jasinskio str. 16, LT2001 Vilnius, Lituania \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Baltia UAB \n\
Konica Minolta Business Solutions Denmark A/S \n\
Lautrupvang 2B, 2750 Ballerup, Dinamarca \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Spain S.A. \n\
C/ Albasanz, 12, 28037 Madrid, España \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Suecia AB \n\
Kronborgsgränd 19, S-164 46 Kista, Suecia o P.O. Box 1125, S-164 22 Kista, Suecia \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Norway AS \n\
Maridalsveien 323, 0872 Oslo, Noruega \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions (Bélgica) N.V. \n\
Excelsiorlaan 10, 1930 Zaventem, Bélgica \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Austria GmbH \n\
Amalienstrasse 59-61, A-1131 Viena, Austria \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Portugal, Unipessoal Lda. \n\
Rua Professor Henrique de Barros nº 4, 10º B 2685-338 Prior Velho, Portugal \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Finland Oy \n\
Keilaranta 10 E, 02150 Espoo, Finlandia \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta, Inc. \n\
2-7-2 Marunouchi, Chiyoda-ku, Tokio, \n\
Japón \n\
dashboard-u_support1@gcp.konicaminolta.com',
    register: 'Registro',
    update: 'Update',
    email: 'dirección de correo electrónico',
    fields_compulsory: 'Todos los campos son obligatorios',
    authorizer_email_error: 'Dirección de correo electrónico del autor no válida.',
    email_error: 'Dirección de correo electrónico no válida.',
    username_error: 'Sólo se pueden introducir caracteres alfanuméricos para el nombre de usuario.',
    serial_number_duplicate_error: 'Los números de serie están duplicados.',
    password_match_error: 'Las contraseñas no coinciden',
    not_km_domain: 'El dominio de la dirección de correo electrónico del autor no es el dominio de konicaminolta',
    registered: '¡¡Registrado!!',
    add_account_email_text: 'Estimado {authorizer},%0D%0A%0D%0A\n{email} ha creado su cuenta de Printer Performance Analysis tool.%0D%0A%0D%0A\n\n\
Cualquier persona que no sea miembro de Konica Minolta puede utilizar esta aplicación con la aprobación de un usuario de Konica Minolta.%0D%0A\n\
Así que, por favor, entre en la URL de abajo y apruébela.%0D%0A%0D%0A\n\
URL %0D%0A\n\
{url} %0D%0A%0D%0A\n\n\
Saludos cordiales, %0D%0A\n\
Konica Minolta Inc.%0D%0A\n\n\
',
    customer_email_text: 'Estimado {email},%0D%0A%0D%0A\ de la siguiente manera%0D%0A\
Hemos creado su cuenta para Printer Performance Analysis tool.%0D%0APor favor, inicie sesión en la siguiente URL.%0D%0A\
URL: https://dashboard-u.konicaminolta.com%0D%0A\
nombre de usuario: {userId}%0D%0A\
password: {password}%0D%0A%0D%0A\
Puede utilizar todas las funciones de esta aplicación después de introducir el PKID en la función de configuración de la licencia.%0D%0A\
*El PKID se le enviará por correo electrónico por separado. Por favor, asegúrese de ello.%0D%0A%0D%0A\
Saludos cordiales,%0D%0AKonica Minolta Inc.',
    request_to_you: 'Le pedimos a usted',
    http_get_error: '{status}: Procesamiento fallido. Vuelva a la pantalla de inicio de sesión.',
    server_error: 'Error interno del servidor.',
    http_connection_error: 'No está conectado a Internet.',
    ce_top_title: 'Seleccione el cliente al que desea conectarse.',
    add_customers_account: 'Añadir la cuenta del cliente',
    go_back: 'Volver',
    customers: 'Sus clientes',
    serial_numbers: 'Números de serie registrados',
    open: 'Abrir',
    add_sn: 'Añadir el número de serie de la impresora',
    add_ce: 'Añadir CE para seguir a este cliente',
    printers_sn: 'Número de serie de la impresora',
    edit_customer_title: 'Editar el registro de clientes',
    customer_email_address: 'Dirección de correo electrónico del cliente',
    license: 'Licencia',
    printers_registered: 'Impresoras registradas',
    serial_number: 'Número de serie',
    latest_data: 'Últimos datos',
    persons_in_charge: 'Personas responsables',
    customer_engineer: 'Ingeniero del cliente',
    sender: 'de',
    authorization: 'Autorización',
    approve: 'Aprobar',
    do_not_approve: 'No aprobar',
    request_approved: '¡Solicitud aprobada!',
    request_disapproved: 'Solicitud desestimada.',
    approved: 'Aprobado',
    do_not_approved: 'Rechazado',
    processed_result: 'Resultado procesado',
    processed_date: 'Fecha de procesamiento',
    header_nfr: 'Licencia de no reventa (NFR)',
    header_recommendation: 'Recomendación',
    header_previous: 'anterior',
    header_next: 'siguiente',
    header_reset: 'reiniciar',
    header_change_password: 'Cambiar contraseña',
    header_settingMenu_tutorial: 'Tutorials',
    header_old_password: 'Contraseña actual',
    header_new_password: 'Nueva contraseña',
    header_confirm_password: 'Nueva contraseña (Confirmar)',
    header_cancel: 'Anular',
    header_apply: 'Aplicar',
    header_ok: 'OK',
    header_close: 'Cerrar',
    from: 'de',
    to: 'a',
    change_date_heading: 'Ajuste del rango',
    change_date_explanation: 'Por favor, seleccione el periodo de tiempo para la exportación del CSV',
    header_password_explanation: 'Por favor, cree una contraseña con una cadena de 8 o más caracteres que incluya letras mayúsculas y minúsculas y números.',
    header_machine_setting: 'Ajuste de la máquina',
    header_machine_setting_title: 'Ajuste de la máquina',
    header_machine_setting_notes: 'Ajuste de la máquina',
    header_machine_setting_model: 'Modelo ',
    header_machine_setting_serial_number: 'S/N：',
    header_machine_setting_machine_name: 'Nombre de la máquina',
    header_machine_setting_error_message_max_length: 'Por favor, introduzca 64 caracteres o menos.',
    header_machine_setting_error_message_min_length: 'Introduzca el nombre de la máquina.',
    header_machine_setting_error_message_common: 'Por favor, compruebe el contenido del nombre de la unidad.',
    header_machine_setting_complete_message: 'La actualización se ha completado. Vuelva a cargar la pantalla.',
    header_lms_setting: 'Configuración de la licencia',
    header_lms_explanation: 'Introduzca la clave de producto notificada por correo electrónico, pulse el botón "remitir" y, a continuación, pulse el botón "activar".',
    header_lms_add: 'Añadir',
    header_lms_delete: 'Borrar',
    header_lms_pkIdTitle: 'Product Key',
    header_lms_refer: 'consulte',
    header_lms_licenseKind: 'tipo de licencia ',
    header_lms_licenseDate: 'licencia caducada',
    header_lms_licenseState: 'activar el estado',
    header_lms_activate: 'activar',
    header_lms_deactivate: 'desactivar',
    header_lms_state_activate: 'activar',
    header_lms_state_deactivate: 'desactivar',
    header_lms_ptl_date: 'La licencia de prueba expirará el',
    header_lms_activationDate: 'Activación disponible',
    header_lms_never_expired: 'Nunca caducado',
    header_users_guide: 'Guía del usuario',
    header_users_guide_link: 'https://www.btapac.konicaminolta.com/users_guide/accuriopress_C14000_series/3_0_0/en/index.html',
    header_version_info: 'Versión',
    screen1_productivity_rate: 'Índice de productividad',
    screen1_productivity_pred: 'Predicción de la productividad',
    screen1_week_before_last_availability: 'Antepenúltima semana',
    screen1_productivity_diff: 'Diferencia real',
    screen1_week_before_last_pred_diff: 'Diferencia entre la previsión de la semana anterior y la real',
    screen1_productivity_a4_tips: 'La productividad se convierte en tamaño A4',
    screen1_productivity_a3_tips: 'La productividad se convierte en tamaño A3',
    screen1_results_of_production: 'Resultados de la producción',
    screen1_est_print_time: 'Tiempo de impresión previsto (hh:mm)',
    screen1_act_print_time: 'tiempo de impresión real (hh:mm)',
    screen1_gap: 'Espacio (hh:mm)',
    screen1_sheets: 'número de impresiones',
    screen1_sheets_per_h: 'número de impresiones/hora',
    screen1_availability: 'Tasa de éxito(%)',
    screen1_job_list_link: 'Lista de pedidos',
    screen1_machine_list_link: 'Lista de máquinas',
    top_manager_title_production_result: 'Total',
    top_manager_title_prints: 'Impresiones',
    top_manager_title_errors: 'errores',
    top_manager_jobs: 'trabajos de impresión',
    top_manager_color_pv: 'páginas en color',
    top_manager_bw_pv: 'Páginas en blanco y negro',
    top_manager_output_paper: 'Páginas impresas',
    top_manager_trayfull_count: 'bandeja de salida llena',
    top_manager_paperjams__count: 'Atasco de papel',
    top_manager_servicecall_count: 'llamada de servicio',
    top_manager_paperempty_count: 'Bandeja de papel vacía',
    top_manager_tonerempty_count: 'Tóner vacío',
    top_operator_title_production_result: 'Resultados del funcionamiento de la unidad',
    top_operator_title_trouble_result: 'Total',
    top_operator_subtitle_output_paper_result: 'Evolución del número de páginas producidas',
    top_operator_subtitle_output_availability_result: 'resultados de la operación',
    top_operator_paper_count: 'Cantidad de papel de salida',
    top_operator_subtitle_output_paper_count: 'Cantidad de papel de salida',
    top_operator_subtitle_interruption_result: 'Resultados de la interrupción (min)',
    top_operator_trayfull: 'bandeja de salida llena',
    top_operator_paperempty: 'Bandeja de papel vacía',
    top_operator_tonerempty: 'Tóner vacío',
    top_operator_paperjams: 'Atasco de papel',
    top_operator_servicecall: 'llamada de servicio',
    top_operator_explanation_worst1: 'Peor factor de parada ',
    top_operator_explanation_worst2: '2º',
    top_operator_explanation_worst3: '3ª ',
    screen3_print_hours: 'horas',
    listofprintjobs_title: 'Lista de pedidos',
    listofprintjobs_number: 'No.',
    listofprintjobs_start_time: 'Hora de inicio',
    listofprintjobs_job_id: 'número de pedido ',
    listofprintjobs_pages_set: 'Páginas/<br>Duplicados',
    listofprintjobs_output_set: 'Duplicados<br>de salida',
    listofprintjobs_exit_count: 'Cantidad de papel de salida',
    listofprintjobs_machine_name: 'máquina',
    jobdetail_left_title: 'detalles del trabajo',
    jobdetail_timeline_title: 'Cronograma de salida',
    jobdetail_job_id: 'número de pedido ',
    jobdetail_size: 'tamaño del papel ',
    jobdetail_paper_kind: 'tipo de papel',
    jobdetail_paper_weight: 'Peso del papel/Espesor',
    jobdetail_color: 'Mono/Color',
    jobdetail_side: 'una cara / doble cara',
    jobdetail_pages: 'Páginas/Duplicados',
    jobdetail_unit_pages: 'Páginas',
    jobdetail_units: 'Duplicados de salida',
    jobdetail_unit_units: 'número de Duplicados',
    jobdetail_sheets: 'Cantidad de papel de salida',
    jobdetail_unit_sheets: 'hojas',
    jobdetail_center_title: 'máquina',
    jobdetail_machine_name: 'Nombre de la máquina',
    jobdetail_tray_full: 'bandeja de salida llena',
    jobdetail_paper_empty: 'Bandeja de papel vacía',
    jobdetail_toner_empty: 'Tóner vacío',
    jobdetail_paper_jam: 'Atasco de papel',
    jobdetail_service_call: 'llamada de servicio',
    jobdetail_panel_operation: 'Panel de operaciones',
    jobdetail_frontdoor_open: 'Puerta frontal',
    jobdetail_tray_open: 'Bandeja de papel',
    jobdetail_right_title: 'Diferencia entre el tiempo de impresión previsto y el real',
    jobdetail_graph_x_title: 'Tiempo de impresión previsto (hh:mm)',
    jobdetail_graph_y_title: 'tiempo de impresión real',
    jobdetail_legend_jobs: 'Salida del trabajo en {machineName}',
    jobdetail_legend_target: 'Este trabajo de impresión',
    jobdetail_tooltip_jobid: 'número de pedido:',
    jobdetail_tooltip_diff: 'La diferencia: ',
    jobdetail_tooltip_actual: 'Tiempo real de impresión: ',
    jobdetail_tooltip_assumed: 'Tiempo estimado de impresión:',
    jobdetail_start_time: 'hora de inicio',
    jobdetail_end_time: 'hora de finalización',
    availabilitydetail_left_title: 'Lista de máquinas',
    availabilitydetail_center_title: 'Diferencia entre las máquinas',
    availabilitydetail_right_title: 'Tendencia del tiempo de impresión por máquina',
    availabilibydetail_unit_hour: 'horas',
    availabilibydetail_machine: 'Máquina',
    availabilibydetail_unit_idle: 'Ocioso',
    availabilibydetail_unit_interruption: 'Interrupción de la impresión',
    availabilibydetail_unit_preparation: 'Preparación de la impresión',
    availabilibydetail_unit_printing: 'está imprimiendo',
    joblist_title: 'Lista de pedidos',
    joblist_number: 'No.',
    joblist_estprinttime: 'Tiempo de impresión previsto (hh:mm)',
    joblist_actprinttime: 'tiempo de impresión real',
    joblist_hourlyunits: 'Páginas de papel por hora',
    joblist_printcompletedtime: 'Hora de impresión (hh:mm)',
    joblist_printtimediff: 'Gap (hh:mm)',
    joblist_csv_export: 'Exportación CSV',
    joblist_est_hourlyunits: 'Páginas previstas por hora',
    joblist_est_printcompletedtime: 'Tiempo de impresión previsto (hh:mm)',
    joblist_act_hourlyunits: 'Páginas reales por hora',
    joblist_act_printcompletedtime: 'tiempo de impresión real',
    proddetail_title: 'Brecha de predicción del tiempo de impresión',
    proddetail_table_title: 'Tendencias del volumen de producción',
    proddetail_graph_yaxis_left: 'Hora de impresión (hh:mm)',
    proddetail_graph_yaxis_right: 'Tasa de éxito(%)',
    proddetail_est_print_time: 'Tiempo de impresión previsto',
    proddetail_act_print_time: 'tiempo de impresión real',
    proddetail_gap: 'Espacio (hh:mm)',
    proddetail_duration_daily: 'diario',
    proddetail_duration_weekly: 'semanal',
    proddetail_duration_monthly: 'mensualmente',
    machinedetail_left_title: 'Detalles de la máquina',
    machinedetail_center_title: 'errores',
    machinedetail_right_title: 'Detalles de la máquina disponible',
    machinedetail_availability: 'disponibilidad',
    machinedetail_operating_time: 'Tiempo de funcionamiento (horas)',
    machinedetail_printing_time: 'Tiempo de impresión (horas)',
    machinedetail_output_set: 'Duplicados de salida',
    machinedetail_output_paper: 'Cantidad de papel de salida',
    machinedetail_power_on: 'Encendido',
    machinedetail_power_off: 'Apagado',
    common_min_per_week: 'min/semana',
    common_2days_ago: 'anteayer',
    common_yesterday: 'ayer',
    common_today: 'Hoy',
    common_tomorrow: 'mañana',
    common_2days_after: 'pasado mañana',
    common_2weeks_ago: 'Hace 2 semanas',
    common_last_week: 'La semana pasada',
    common_this_week: 'esta semana',
    common_next_week: 'la próxima semana',
    common_2weeks_after: 'la semana siguiente',
    common_2months_ago: 'Hace 2 meses',
    common_last_month: 'último mes',
    common_this_month: 'este mes',
    common_next_month: 'próximo mes',
    common_2months_after: 'mes siguiente al mes siguiente',
    common_days_ago: '{dateNum} días atrás',
    common_weeks_ago: 'Hace {dateNum} meses',
    common_months_ago: 'Hace {dateNum} meses',
    common_days_after: '{dateNum} días después',
    common_weeks_after: '{dateNum} semanas después',
    common_months_after: '{dateNum} meses después',
    common_mins: 'minutos',
    common_hours: 'horas',
    common_date: 'Fecha',
    common_percentage: '%',
    icon_recommendation: 'Recomendación',
    icon_analysis: 'Análisis',
    icon_operation: 'Operación',
    icon_machine: 'Máquina',
    icon_material: 'Material',
    icon_method: 'Método',
    icon_running_time: 'tiempo de funcionamiento',
    icon_preparation_time: 'Preparación de la impresión',
    icon_downtime: 'Interrupción de la impresión',
    paperEmpty: 'papel vacío',
    tonerEmpty: 'tóner vacío',
    trayFull: 'Depósito de papel lleno',
    Total: 'Total',
    Average: 'AVE.',
    hour_unit: 'horas',
    date_format: 'DD.MM.YY',
    date_format2: 'DD.MM',
    month_format: 'MM.YY',
    errCode_10000: 'El cambio de contraseña ha fallado.',
    errCode_10001: 'Nueva contraseña y Nueva contraseña (Confirmar) no coinciden.',
    errCode_10002: 'La contraseña debe ser una cadena de caracteres de al menos 8 caracteres, incluyendo letras mayúsculas y minúsculas y números',
    errCode_10003: 'Espere unos 10 minutos y vuelva a cambiar su contraseña',
    errCode_10004: 'La contraseña actual es incorrecta.',
    errCode_10005: 'Su sesión ha expirado. Por favor, inicie sesión de nuevo.',
    errCode_10006: 'Se ha producido un error de red.',
    errCode_10100: 'Se ha producido un error. Por favor, póngase en contacto con el administrador.',
    errCode_10101: 'Por favor, introduzca la clave del producto.',
    errCode_10102: 'No se ha podido obtener la información de la clave de producto.',
    errCode_10103: 'La activación ha fallado.',
    errCode_10104: 'Desactivación fallida.',
    errCode_10105: 'No se ha podido eliminar la información de la clave de producto.',
    errCode_10106: 'No se puede establecer la misma clave de producto.',
    errCode_10007: 'Compruebe el correo electrónico de verificación e inicie sesión desde el enlace que figura en el cuerpo del correo electrónico.',
    errCode_20000: 'El parámetro es inválido.',
    errCode_20001: 'La dirección de correo especificada ya existe.',
    errCode_20002: 'El nombre de usuario especificado ya existe. Por favor, especifique otro nombre de usuario.',
    errCode_20003: 'El nombre de usuario especificado no está registrado como cliente.',
    suggestion_overview: 'Resumen',
    suggestion_pgap_overview_good: 'La brecha de predicción ha disminuido',
    suggestion_pgap_overview_bad: 'brecha de Predicción ha aumentado',
    suggestion_pgap_overview_even: 'La brecha de predicción no ha cambiado',
    suggestion_ma_overview_good: 'La tasa de disponibilidad ha aumentado',
    suggestion_ma_overview_bad: 'La tasa de disponibilidad ha disminuido',
    suggestion_ma_overview_even: 'La tasa de disponibilidad no ha cambiado',
    suggestion_attention_machine: 'la máquina requiere atención: ',
    suggestion_tips: 'Consejos',
    suggestion_pv_up: 'Aumento del volumen de impresión',
    suggestion_pv_down: 'El volumen de impresión ha disminuido',
    suggestion_pv_even: 'El volumen de impresión no ha cambiado',
    suggestion_downtime_long: 'Aumento del tiempo de inactividad',
    suggestion_smalljob_many: 'Aumentan los trabajos en lotes pequeños',
    suggestion_efficiency_up: 'La eficiencia de la producción ha aumentado',
    ce_login_tutorial: 'Para la implementación, consulte el tutorial',
    ce_dialog_header_confirm: 'Confirmación',
    ce_confirmation_message: '¿Realmente quiere actualizar los datos del cliente?',
    ce_email_confirmation: 'Se creará el correo electrónico de inicialización de la contraseña del cliente. ¿Está seguro?',
    username_email: 'Nombre de usuario (dirección de correo electrónico)',
    ce_dialog_header_info: 'Información',
    ce_account_complete_kmce: 'El registro de la cuenta se ha completado. Vaya a la pantalla de inicio de sesión.',
    ce_account_complete_dealer: 'La solicitud de registro de la cuenta se ha completado. Por favor, espere hasta que sea aprobada.',
    ce_user_account_complete_kmce: 'El registro de la cuenta se ha completado.',
    ce_user_account_complete_dealer: 'La solicitud de registro de la cuenta se ha completado. Por favor, espere hasta que sea aprobada.',
    ce_error_400: 'Se ha producido un error. Por favor, compruebe el contenido.',
    ce_error_409: 'Volver a adquirir información porque ha sido actualizada por otro usuario',
    ce_top_operator_user_name: 'Pantalla del operador superior de {userName}',
    add_new_customer: 'Añadir un nuevo cliente',
    add_existed_customer: 'Añadir cliente existente',
    ce_edit_licenseExpiresOn: 'Expira el',
    send_mail: 'Correo enviado con éxito.',
    password_change_complete: 'Cambio de contraseña completado.',
    reset_password: 'Restablecimiento de la contraseña',
    change_button: 'cambiar',
    send_button: 'enviar',
    common_error_500: 'No se ha podido procesar.',
    error_send_mail: 'No se ha podido enviar el correo.',
    error_confirm_password_incorrect: 'La contraseña y la contraseña de confirmación son diferentes.',
    error_usename_not_exist: 'El nombre de usuario especificado no existe.',
    error_id_not_exist: 'El identificador especificado no existe.',
    error_id_mailaddress_not_exist: 'El identificador o la dirección de correo electrónico especificados no existen.',
    ce_forget_password_dialog_message: 'Envíe un correo electrónico de cambio de contraseña. Cambie su contraseña desde la URL descrita en el cuerpo del correo electrónico.',
    user_forget_password_dialog_message: 'Por favor, vuelva a confirmar si desea cambiarlo, ya que esto afectará a todos los miembros que utilicen esta cuenta. Se le enviará el correo electrónico con la nueva contraseña. Por favor, inicie sesión con la contraseña proporcionada en el correo electrónico. Si no conoce su dirección de correo electrónico, póngase en contacto con el responsable de la CE.',
    Mon: 'Lun',
    Tue: 'Mar',
    Wed: 'Mié',
    Thu: 'Jue',
    Fri: 'Ven',
    Sat: 'Sáb',
    Sun: 'Dom',
    header_pending_verification: 'Pendiente de verificación',
    pending_verification_dialog_message: 'La cuenta está bloqueada porque no se ha utilizado durante mucho tiempo. Es necesario enviar un correo electrónico de confirmación?',
    trial_license_expired_message: 'La licencia de prueba ha caducado. Introduzca la clave del producto',
    errCode_20004: 'URL no válida',
    error_code: 'Código de avería',
    jam_location: 'Localización de atascos',
    device_time: 'marca de tiempo',
    machine_name: 'Máquina',
    paperJamsList_title: 'Lista de atascos de papel',
    error_support: 'Solución',
    error_describe: 'Detalle del error',
    serviceCallList_title: 'Lista de llamadas de servicio',
    tray: 'Bandeja de entrada',
    paperEmptyList_title: 'Lista de informes de vacantes en papel',
    output_tray_name: 'Bandeja de salida',
    trayFullList_title: 'Bandeja de lista de mensajes completos',
    tonerEmptyList_title: 'Lista de mensajes de tóner vacío',
    toner_color: 'Color del tóner',
    errorCount_tip: 'La lista se ha suspendido por análisis o restricción de número',
    solve_time: 'tiempo de resolución',
    change_language: 'Cambiar idioma',
    machine_tab: 'Básico',
    custom_group_tab: 'personalizado',
    group_name: 'nombre del grupo',
    group_checkbox_tip: 'El grupo seleccionado podrá seleccionarse en la interfaz de usuario.',
    group_edit_tip: 'Puede añadir un conjunto personalizado de visualización de la máquina.',
    custom_group: 'Nombre de grupo definido por el usuario',
    group_comment: 'Comentario',
    machine_checkbox_tip: 'La máquina seleccionada se mostrará cuando se seleccione el grupo',
    group_name_exits: 'El nombre de grupo especificado ya existe.',
    header_group_name_max_length: 'Por favor, introduzca 64 caracteres o menos.',
    header_group_name_min_length: 'Introduzca el nombre del grupo.',
    header_group_comment_max_length: 'Por favor, introduzca 128 caracteres o menos.',
    header_device_group_switch: 'Grupo de dispositivos:',
    header_group_all: 'Todos(hojas)',
    header_group_color: 'Color',
    header_group_monochrome: 'blanco y negro',
    header_group_detail_length: 'Debe seleccionarse al menos una máquina en el grupo personalizado.',
    header_group_select_tip: 'No hay ninguna máquina en el grupo seleccionado. Registre la máquina en el grupo.',
    group_name_specialchar_tip: 'No se puede introducir el carácter especial @.',
    change_date_heading_week: 'Selector de semana',
    machine_time_line: 'línea de tiempo',
    header_group_ppall: 'AccurioPress/Print',
    header_group_km1: 'AccurioJet',
    top_manager_otherTransporterror_count: 'Otro error de transporte',
    otherTransportErrorList_title: 'Lista de otros errores de transporte',
    jobdetail_otherTransporterror: 'Otro error de transporte',
    top_operator_otherTransporterror: 'Otro error de transporte',
    errCode_10008: 'La llave está mal o caducada.',
    feeder: 'Alimentar',
    license_expired_message: 'Su permiso ha caducado',
    logout_dialog_msg: 'No se pueden utilizar todas las funciones hasta que la licencia sea válida. ',
    header_logout_yes: 'cerrar sesión',
    header_logout_no: 'Anular',
    paper_weight: 'peso del papel',
    paper_thickness: 'Espesor',
    errCode_10009: 'La SN no está registrada.',
    errCode_10010: 'Inicio de sesión obligatorio',
    errCode_10011: 'Ningún dispositivo registrado',
    ce_reset_password_dialog_title: 'Notificación de información sobre la cuenta del cliente',
    ce_reset_password_dialog_ultimate: 'Reiniciar Op-Analysis',
    ce_reset_password_dialog_job_manager: 'Reiniciar JobManager',
    ce_reset_password_dialog_all: 'Restablecer ambos',
    customer_email_text_job_manager: 'Estimado {email},%0D%0A%0D%0A\
Hemos creado su cuenta para AccurioPro Dashboard JobManager.%0D%0Por favor, inicie sesión en la siguiente URL.%0D%0A\
URL: https://dashboard-jm.konicaminolta.com%0D%0A\
Nombre de usuario: {userId}%0D%0A\
ID de operador: administrador%0D%0A\
password: {password}%0D%0A%0D%0A\
Puede utilizar todas las funciones de esta aplicación después de introducir la clave de producto en la función de configuración de licencia.%0D%0A\
*La clave del producto se le enviará por correo electrónico por separado. Por favor, asegúrese de ello.%0D%0A%0D%0A\
Saludos cordiales,%0D%0AKonica Minolta Inc.',
    customer_email_text_all: 'Estimado {email},%0D%0A%0D%0A\
Hemos creado su cuenta para Printer Performance Analysis tool y AccurioPro Dashboard JobManager.%0D%0Por favor, inicie sesión en la siguiente URL.%0D%0A\
URL: https://dashboard-u.konicaminolta.com%0D%0A\
Nombre de usuario: {ultimateUserId}%0D%0A\
ID de operador: administrator%0D%0A\
Contraseña definitiva: {ultimatePassword}%0D%0A\
Contraseña de JobManager: {jobManagerPassword}%0D%0A%0D%0A\
Puede utilizar todas las funciones de esta aplicación después de introducir la clave de producto en la función de configuración de licencia.%0D%0A\
*La clave del producto se le enviará por correo electrónico por separado. Por favor, asegúrese de ello.%0D%0A%0D%0A\
Saludos cordiales,%0D%0AKonica Minolta Inc.',
    TZ_0000: 'Europe/West/GB, PT (+0)',
    TZ_0100: 'Europe/Central/FR, DE (+1)',
    TZ_0200: 'Europe/East/UA, GR (+2)',
    TZ_0300: 'Europe/East/TR, Moscow (+3)',
    TZ_0630: 'Asia/India (+5.5)',
    TZ_0700: 'Asia/Viet Nam (+7)',
    TZ_0800: 'Asia/China (+8)',
    TZ_0900: 'Asia/Japan, Korea (+9)',
    TZ_1400: 'Pacific/Hawaii (-10)',
    TZ_1500: 'America/Alaska (-9)',
    TZ_1600: 'America/West/Los Angeles (-8)',
    TZ_1700: 'America/Mountain/Denver (-7)',
    TZ_1800: 'America/Central/Chicago (-6)',
    TZ_1900: 'America/East/New York (-5)',
    TZ_2100: 'South America/Sao Paulo (-3)',
    time_zone_title: 'zona horaria',
    local_time: 'Hora local',
    header_user_id: 'Nombre de usuario',
    ce_customers_list_title: 'Lista de clientes',
    ultimate_license_expires_on: 'Op-Analysis (fecha de caducidad)',
    jm_license_expires_on: 'Job Manager (fecha de expiración)',
    ce_customers_list_search: 'busque en',
    ce_edit_registered: 'registrado',
    ce_edit_serialNumber: 'Número de serie (máquina de impresión)',
    ce_edit_lastUpdatedDate: 'Fecha de la última actualización',
    ce_edit_responsibleCE: 'Ingeniero responsable del cliente',
    ce_edit_customerInfo: 'Información al cliente',
    ce_edit_utimate: 'Op-Analysis',
    ce_edit_addSerialNumber: 'Añadir número de serie',
    ce_edit_jobManager: 'Job Manager',
    ce_edit_commonInfo: 'Información común',
    ce_header_editCustomers: 'Editar cliente',
    ce_add_addCustomers_title: 'Puede añadir una nueva cuenta de cliente',
    ce_serial_number_list: 'Número de serie',
    ce_essential_link_file: 'Essential Linked file',
    ce_location_on_off: 'Beta features on / off',
    date: 'Date',
    before_suggistion: 'Original suggestion text',
    after_suggestion: 'Suggestion to be updated',
    batch_edit: 'Bulk update',
    data_error: 'The data has been updated. Please refresh and save again.',
    edit_suggestion: 'Edit Suggestion',
    suggestion: 'Suggestion',
    user_suggestion_list: 'Suggestion list',
    delete_suggestion: 'Delete',
    top_operator_adjustment: 'Maintenance',
    color: 'Color',
    monochrome: 'Mono',
    duplex: 'doble cara',
    simplex: 'una cara',
    undefined_paper: 'Ninguno',
    normal_paper: 'Papel normal',
    colored_paper: 'Papel de color',
    high_quality_paper: 'Papel de alta calidad',
    color_paper: 'Papel impreso en color',
    coated_gloss_laser_paper: 'Papel couché láser satinado',
    coated_mat_laser_paper: 'Papel couché láser mate',
    coated_gloss_offset_paper: 'Papel couché offset satinado',
    coated_mat_offset_paper: 'Papel couché offset mate',
    embossing_paper: 'Papel gofrado',
    envelope: 'Sobre',
    rough_paper: 'Papel rugoso',
    book_paper: 'Papel libro',
    coated_paper: 'Papel couché',
    preprinted_paper: 'Papel preimpreso',
    blank_insert_paper: 'Papel para inserción de hoja en blanco',
    generate_suggestion: 'Automated suggestion',
    error_Duration: 'Error Duration',
    jobdetail_processing_time: 'Processing Time',
    job_start_time: 'Hora de inicio',
    job_end_time: 'hora de finalización',
    add_customer_user_id: 'User name (for Customer login)',
    add_customer_email_address: 'Customer contact e-mail address',
    change_date_heading_day: 'Date selector',
    no_log: 'Dashboard Op-Analysis logs are not sent to CSRA/CSRC',
    unused_log: 'Dashboard Op-Analysis logs are not included in CSRA/CSRC logs',
    datetime_format: 'DD.MM.YY HH:mm:ss',
    header_jobs: 'Jobs',
    no_rows_label: 'Datos no disponibles',
    date_format3: 'DD.MM HH:mm',
    aqa_main_reason_fd_k: 'Vertical streak K',
    aqa_main_reason_fd_c: 'Vertical streak C',
    aqa_main_reason_fd_m: 'Vertical streak M',
    aqa_main_reason_fd_y: 'Vertical streak Y',
    aqa_main_reason_cd_k: 'Horizontal streak K',
    aqa_main_reason_cd_c: 'Horizontal streak C',
    aqa_main_reason_cd_m: 'Horizontal streak M',
    aqa_main_reason_cd_y: 'Horizontal streak Y',
    aqa_main_reason_dba_k: 'Uneven density K',
    aqa_main_reason_dba_c: 'Uneven density C',
    aqa_main_reason_dba_m: 'Uneven density M',
    aqa_main_reason_dba_y: 'Uneven density Y',
    aqa_main_reason_spot_k: 'Spot K',
    aqa_main_reason_spot_c: 'Spot C',
    aqa_main_reason_spot_m: 'Spot M',
    aqa_main_reason_spot_y: 'Spot Y',
    aqa_main_reason_backside_stain: 'Stain',
    machine_detail_timeline: 'Machine Detail Timeline',
    machine_detail_score_transition: 'Image total score transition',
    machine_detail_score_details: 'Diagnostic score details',
    machine_detail_diagnostic_history: 'DIAGNOSTIC HISTORY (Simple/Detailed)',
    machine_detail_dba_history: 'Maximum density transition',
    aqa_score_trend: 'Score',
    aqa_score_average_28days_trend: 'Trend (28 days average)',
    day_time: 'Date time',
    machine_id: 'MachineID',
    overall_score: 'Overall Score',
    main_factors: 'Main factors',
    machine_detail_score: 'Comprehensive image score',
    machine_detail_score_last_date: 'Latest date',
    machine_detail_score_last_num: 'Latest score',
    machine_detail_score_average_num: 'Historical average score',
    machine_detail_score_major_factor: 'Main factor',
    machine_detail_score_last: 'Latest score:',
    machine_detail_score_average_28days: '28 days average score:',
    aqa_diagnostic_score_legend_error: 'Error',
    aqa_diagnostic_score_legend_warning: 'Warning',
    aqa_diagnostic_score_legend_ok: 'OK',
    aqa_diagnostic_score_subtitle: 'Diagnostic Item',
    aqa_color: 'Color',
    aqa_fd_streak_rank: 'Vertical streak',
    aqa_cd_streak_rank: 'Horizontal streak',
    aqa_cd_banding_rank	: 'CD Banding',
    aqa_blurry_white_spot: 'White spot noise',
    aqa_blurry_color_spot: 'Color spot noise',
    aqa_white_spot: 'White speckle',
    aqa_black_spot: 'Black speckle',
    aqa_inky_backside: 'Stain',
    aqa_uneven_density: 'Uneven density',
    aqa_dba_adapt: '(Adjusted)',
    aqa_quality_information: 'Display AQA Quality Information',
    ce_sn_validation: 'Serial number should be 13 characters for KM printer',
    aqa_history_table_title: 'Image diagnosis (Simple/Detailed)',
    date_format4: 'DD.MM.YY HH:mm',
    header_group_AccurioLabel: 'AccurioLabel',
    header_group_registered_mixed_error: 'Web-fed machine can\'t be registered mixed with sheet-fed machine',
    label_machine_printed_length: 'Print length',
    label_machine_printed_length_with_unit: 'Print length(m)',
    label_machine_act_printed_length_with_unit: 'Act. Print length(m)',
    label_machine_printed_length_unit: 'm',
    label_machine_printed_length_time_unit: 'm/hour',
    label_machine_printed_length_with_unit2: 'Length/Set',
    label_machine_top_operator_subtitle_printed_length_result: 'Trend of print length',
    label_machine_top_operator_act_printed_length: 'Act. Print length',
    label_machine_screen_sheets_per_h: '#of prints(m/hour)',
    label_machine_joblist_est_hourlyunits: 'Pred. Print length(m/hour)',
    label_machine_joblist_act_hourlyunits: 'Act. Print length(m/hour)',
    header_machine_setting_remove_group_confirmation: 'Are you sure you want to remove this group "{group}"?',
    machinedetail_passed_day: '(Last 7 Days)',
    machinedetail_passed_week: '(Last 4 Weeks)',
    machinedetail_passed_month: '(Last 4 Months)',
    label_machine_waste_paper_length: 'Waste paper length',
    change_disabled_date_heading: 'Range',
    change_disabled_date_explanation: 'The duration of the CSV export',
    ce_edit_transportLog: 'Transport Log',
    ce_edit_transportLog_dialog_title: 'Transport Log Setting',
    ce_edit_transportLog_dialog_no: 'No.',
    ce_edit_transportLog_dialog_dev_env: 'Transport dev',
    ce_edit_transportLog_dialog_dev_stag: 'Transport sam',
    current_page: 'Current page:',
    total_pages: 'Total Pages:',
    ds_version_title: 'Version',
    ds_dashboard_version: 'KONICA MINOLTA AccurioPro Dashboard CE Version',
    ds_version_ds_num: '1.4.3',
    ds_version_oss: 'Disclosure of OSS information',
    ds_version_copyright: 'Copyright(C)2022',
    ds_version_companyName: 'KONICA MINOLTA.INC.',
    ds_import_cancle_btn: 'Close',
    header_settingMenu_version: 'Version',
    ce_application_sub_title: 'For Customer Engineers',
    ce_authorizer: 'Approver Email Address',
    ce_addCustomers_JMAndAQA_title: 'Both JobManager and Op-Analysis',
    ce_request_subTitle: 'Customer Info',
    ce_request_header_date: 'request date',
    ce_request_header_contents: 'contents',
    ce_header_link_request: 'request confirm',
    ce_edit_email_button: 'edit',
};
export default es;
